import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { CustomersService } from 'src/app/services/customer.service';
import { VistMetricsComponent } from './visit-metrics/vist-metrics.component';
import { OpportunityMetricsComponent } from './opportunity-metrics/opportunity-metrics.component';
import { OrderMetricsComponent } from './order-metrics/order-metrics.component';
import { VisitAndTaskMetricsComponent } from './visit-and-task-metrics/visit-and-task-metrics.component';
import { ReferralMetricsComponent } from './referral-metrics/referral-metrics.component';

@Component({
  selector: 'kt-customer-insight',
  templateUrl: './customer-insight.component.html',
  styleUrls: ['./customer-insight.component.css']
})
export class CustomerInsightComponent implements OnInit {

  @Input() customerId: number;
  selectedTabIndex = 0;
  currentUser: any = {};
  permisions: any[] = [];
  private loadingSubject = new BehaviorSubject<boolean>(true);
  loading$ = this.loadingSubject.asObservable().pipe(shareReplay(1));

  @ViewChild('visitMetrics', { static: false }) visitMetrics!: VistMetricsComponent;
  @ViewChild('opportunityMetrics',{ static: false }) opportunityMetrics: OpportunityMetricsComponent;
  @ViewChild('orderMetrics',{ static: false }) orderMetrics: OrderMetricsComponent;
  @ViewChild('taskMetrics',{ static: false }) taskMetrics: VisitAndTaskMetricsComponent;
  @ViewChild('referralMetrics',{ static: false }) referralMetrics: ReferralMetricsComponent;
  @ViewChild('visitMetricsFinancial',{ static: false }) visitMetricsFinancial: VistMetricsComponent;
  @ViewChild('opportunityMetricsFinancial',{ static: false }) opportunityMetricsFinancial: OpportunityMetricsComponent;
  @ViewChild('orderMetricsFinancial',{ static: false }) orderMetricsFinancial: OrderMetricsComponent;
  @ViewChild('taskMetricsFinancial',{ static: false }) taskMetricsFinancial: VisitAndTaskMetricsComponent;
  @ViewChild('referralMetricsFinancial',{ static: false }) referralMetricsFinancial: ReferralMetricsComponent;

  private loadingStates: boolean[] = [false, false, false, false, false]; // Track each child's load state
  private currentRefreshCycle = 0; // Track the current refresh cycle
  currency:any;

  constructor(
    private customerService: CustomersService,
    // private authService: AuthService
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);

    // this.authService.getPermissions().subscribe((x) => {
    //   this.currentUser = x.currentUser;
    //   this.permisions = x.Permissions.map((permission: any) => permission.SystemName);
    // });
    this.customerService.getCurrencySymbol(this.customerId).pipe(map(res =>{
      this.currency = res.currency;
    })).subscribe();
  }

  refresh() {
    this.loadingSubject.next(true)

    this.loadingStates = [false, false, false, false, false];
    this.currentRefreshCycle++;

    // Trigger data fetch for all child components
    if(this.selectedTabIndex==0){
      this.visitMetrics.fetchVisitMetrics();
      this.orderMetrics.fetchMostOrderedProducts();
      this.orderMetrics.fetchOrderMetrics();
      this.opportunityMetrics.fetchOpportunityMetrics();
      this.taskMetrics.fetchVisitAndTaskMetrics();
      this.referralMetrics.fetchReferralBusiness();
    }
    else {
      this.visitMetricsFinancial.fetchVisitMetrics();
      this.orderMetricsFinancial.fetchMostOrderedProducts();
      this.orderMetricsFinancial.fetchOrderMetrics();
      this.opportunityMetricsFinancial.fetchOpportunityMetrics();
      this.taskMetricsFinancial.fetchVisitAndTaskMetrics();
      this.referralMetricsFinancial.fetchReferralBusiness();
    }
  }
  
  onTabChange(event: any) {
    this.selectedTabIndex = event.index;
    this.loadingSubject.next(true);
    this.loadingStates = [false, false, false, false, false];
  }

  onChildLoaded(childIndex: number) {
    this.loadingStates[childIndex] = true;
    if (this.loadingStates.every((state) => state)) {
      this.loadingSubject.next(false)// Stop the loader
    }
  }

}
